<template>
  <div
    data-app-header
    class="header-voyada"
    ref="innerElement"
    :class="isTop || transparent === '1' ? 'bbg' : 'whitebg'"
  >
    <div class="header-inner">
      <div class="right">
        <a href="/" class="logo pc">
          <img src="/images/logo.png" class="bg" alt="logo" />
          <img src="/images/logo_g.png" class="bg" alt="logo" />
        </a>
        <a href="/" class="logo flex_mobile">
          <img src="/images/logo_g.png" class="bg" alt="logo" />
          <img src="/images/logo.png" class="bg" alt="logo" />
        </a>
      </div>
      <div class="right nav-right">
        <div v-if="isDesktop" class="header-phone-us">
          <img src="/images/home/phone-icon.svg" class="header-phone-icon" alt="" />
          <span>{{ currentContact.region }}: {{ currentContact.number }}</span>
        </div>
        <div v-if="isDesktop" class="wapnav wapnav--menu">
          <MegaMenuVoyada />
        </div>
        <div v-if="isDesktop" class="wapnav" :class="isshownav ? 'open' : ''">
          <CurrencySelector />
          <div class="user-actions">
            <div
              @mouseenter="emit('showUmenu')"
              @mouseleave="emit('update:showUserNav', false)"
              class="borderbox profilebox"
              v-if="!isLogin"
            >
              <!-- Clicking Login opens the login dialog directly; hovering still shows Login / Sign up. -->
              <button type="button" class="login-trigger" @click="emit('changePage', 'login')">
                <i class="icon_user"></i>
                <span>{{ t('common.login') }}</span>
              </button>
              <div class="block usermenu usermenu--login" v-if="showUserNav">
                <div class="usermenu-spacer"></div>
                <div class="usernav">
                  <div class="r nonemember" @click="emit('changePage', 'login')">
                    <img src="/images/icon_user_b.png" class="usernav-icon" />
                    {{ t('common.login') }}
                  </div>
                  <div class="userline"></div>
                  <div class="r nonemember" @click="emit('changePage', 'register')">
                    <img src="/images/pen.png" class="usernav-icon" />
                    {{ t('common.signup') }}
                  </div>
                </div>
              </div>
            </div>
            <div
              @mouseenter="emit('showMUmenu')"
              @mouseleave="emit('update:showUserNav', false)"
              class="borderbox profilebox profilebox--wide"
              v-else
            >
              <div>
                <img
                  v-if="avatarUrl && avatarUrl != ''"
                  class="avatar-img"
                  :src="dataUrl(avatarUrl)"
                  alt=""
                />
                <img
                  v-else-if="avatar != ''"
                  class="avatar-img"
                  :src="
                    dataUrl(
                      !isTop && avatar === '/images/icon_user.png'
                        ? '/images/icon_user_b.png'
                        : avatar
                    )
                  "
                  alt=""
                />
                <span class="user-name">{{ lastName }}/{{ firstName }}</span>
                <span class="agent-id" v-if="customerGroupId == '3'">
                  | {{ t('common.agentid') }}: {{ accountId }}
                </span>
              </div>
              <div class="block usermenu" v-if="showUserNav">
                <div class="usermenu-spacer usermenu-spacer--member"></div>
                <div class="usernav">
                  <UserMenu @setLogout="emit('setLogout')" />
                </div>
              </div>
            </div>
            <div class="borderbox profilebox wap">
              <i class="icon_user"></i>
              <span> {{ t('common.signup') }}</span>
            </div>
          </div>
        </div>

        <div v-if="!isDesktop" class="mobile-icons">
          <CurrencySelector v-if="showCurrencySelector" :readonly="isOrderPage" />
          <ITablerBell class="mobile-icon" @click="emit('showNotice')" />
          <ITablerMenu2 class="mobile-icon" @click="emit('switchLeftMenu')" />
        </div>
      </div>
    </div>
  </div>

  <MobileMenu :open="showMobileLeftMenu" @close="emit('closeMobileMenu')" />

  <Teleport to="body">
    <MobileNav />
  </Teleport>

  <VoyadaFab v-if="voyadaEnabled" />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { watch, computed, inject } from 'vue'
import { routeLocationKey } from 'vue-router'
import { useWindowSize } from '@vueuse/core'
import MegaMenuVoyada from './MegaMenuVoyada.vue'
import MobileNav from './MobileNav.vue'
import UserMenu from '@/components/usermenu.vue'
import { useVoyadaFlag } from '@/composables/useVoyadaFlag'
import VoyadaFab from '@/components/voyada/VoyadaFab.vue'
import MobileMenu from '@/components/MobileMenu.vue'
import CurrencySelector from '@/components/CurrencySelector.vue'
import { useHomepagePhoneContacts } from '@/composables/homepage'
import { showMobileAccountSheet } from '@/composables/useMobileMenu'
import { dataUrl } from '@/utils/AssetUtils'

const { enabled: voyadaEnabled } = useVoyadaFlag()

const { t } = useI18n()

const { currentContact } = useHomepagePhoneContacts()
const { width } = useWindowSize()
const isDesktop = computed(() => width.value > 1280)

// Order-flow steps price everything in the order's currency, so the mobile switcher is
// hidden there. inject() with a default instead of useRoute(): some page entries
// (e.g. /user/bookings/) have no router.
const ORDER_FLOW_ROUTES = ['flight', 'booking', 'payment', 'insurance']
const route = inject(routeLocationKey, null)
const showCurrencySelector = computed(
  () => !ORDER_FLOW_ROUTES.includes(String(route?.name ?? ''))
)

// Order pages: the switcher still shows (the page pins the store to the order's currency,
// same as PC), but an order's currency can't be changed, so it's read-only there.
const ORDER_PAGE_PATH = /^\/user\/(bookings|flight|insurance|payment|invoice|refund)(\/|$)/
const isOrderPage = ORDER_PAGE_PATH.test(window.location.pathname)

const props = defineProps<{
  isTop: boolean
  transparent: string
  isshownav: boolean
  showUserNav: boolean
  showMobileLeftMenu: boolean
  isLogin: boolean
  avatarUrl?: string
  avatar: string
  firstName: string
  lastName: string
  customerGroupId: string
  accountId: string
}>()

watch(
  () => props.showMobileLeftMenu,
  (open) => {
    if (open) showMobileAccountSheet.value = false
  }
)

watch(isDesktop, (desktop) => {
  if (desktop) showMobileAccountSheet.value = false
})

const emit = defineEmits<{
  showUmenu: []
  showMUmenu: []
  'update:showUserNav': [value: boolean]
  changePage: [page: string]
  setLogout: []
  showNotice: []
  switchLeftMenu: []
  closeMobileMenu: []
}>()

</script>

<style scoped lang="scss">
.header-voyada {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  box-sizing: border-box;
  color: #fff;
  height: 70px;
  padding: 0 60px;
}

.header-inner {
  max-width: 1520px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-voyada.bbg {
  transition: all 0.3s ease 0s;
  color: #fff;
  background: linear-gradient(to bottom, rgba(50, 49, 49, 0.5), rgba(41, 40, 40, 0));
}

.header-voyada.whitebg {
  background: #fff;
  color: #333;
  transition: all 0.3s ease 0s;
}

.header-voyada .logo {
  width: 150px;
}

.header-voyada .logo img:first-child {
  display: none;
}
.header-voyada.bbg .logo img:first-child {
  display: block;
}
.header-voyada.bbg .logo img:last-child {
  display: none;
}

.header-voyada .right,
.header-voyada .wapnav,
.header-voyada .listbox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-voyada .borderbox {
  margin-left: 12px;
  border: 1px solid #eaeaea;
  padding: 0 12px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 18px;
  cursor: pointer;
}

.header-voyada .borderbox span {
  margin-left: 6px;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 20px;
}

.header-voyada .borderbox > div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-voyada .borderbox i {
  display: block;
  width: 20px;
  height: 20px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.header-voyada .borderbox i.icon_user {
  background-image: url(/images/icon_user.png);
}
.header-voyada.whitebg .borderbox i.icon_user {
  background-image: url(/images/icon_user_b.png);
}

.header-voyada.bbg .profilebox {
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
}
.header-voyada.whitebg .profilebox {
  border: 1px solid #4f6f52 !important;
}
.nonemember {
  width: 60%;
  margin: auto;
}

.usermenu {
  position: absolute;
  top: 15px;
  right: 0px;
  z-index: 99999;
  justify-content: flex-start;
  align-items: flex-start;
}

.usernav {
  padding: 5px 5px;
  height: auto;
  width: 190px;
  background: #fff;
  border-radius: 10px;
  color: #333;
  z-index: 9999 !important;
}

.usernav .r {
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: 12px;
}

.usernav .r:hover {
  background: #e5e5e5;
  border-radius: 15px;
}

.usernav img {
  height: 25px;
  width: 25px;
  margin-right: 5px;
}

.userline {
  border-top: 1px solid #ddd !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.nav-right {
  justify-content: flex-start;
}

.wapnav--menu {
  padding-right: 60px;
}

.user-actions {
  display: flex;
  position: relative;
}

/* Start the login menu right under the Login button: it used to cover the button and swallow its click. */
.usermenu--login {
  top: 100%;
  height: 120px;
}

.usermenu-spacer {
  height: 65px;
}

.usermenu-spacer--member {
  height: 25px;
}

.usernav-icon {
  padding: 0;
  height: 19px;
  width: 19px;
  margin-right: 3px;
}

.avatar-img {
  width: 23px;
  height: 23px;
  border-radius: 50%;
}

.user-name {
  font-size: 1.4rem;
}

.agent-id {
  font-size: 1.4rem;
  padding-left: 0.2rem;
  font-weight: normal;
}

.login-trigger {
  display: inline-flex;
  align-items: center;
  gap: inherit;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
}
.login-trigger:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.profilebox--wide {
  width: auto;
}

.header-phone-us {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-right: 2.4rem;
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 600;
  white-space: nowrap;
  color: inherit;
}
.header-phone-icon {
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
  flex-shrink: 0;
}

.header-voyada.bbg .header-phone-icon {
  filter: brightness(0) invert(1);
}
.header-voyada.whitebg .header-phone-icon {
  filter: none;
}

.flex_mobile {
  display: none;
}
.pc {
  display: block;
}

@media screen and (max-width: 1280px) {
  .flex_mobile {
    display: flex !important;
    justify-items: flex-start !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
  }

  .pc {
    display: none;
  }

  .header-voyada {
    background-color: transparent;
    height: 56px;
    padding: 0;
    z-index: 1000;
  }

  .header-inner {
    padding: 0 24px;
  }

  .header-voyada.bbg,
  .header-voyada.whitebg {
    height: 56px;
    padding: 0;
  }

  .header-voyada.bbg {
    color: #fff;
    background: linear-gradient(to bottom, rgba(50, 49, 49, 0.5), rgba(41, 40, 40, 0));
  }

  .header-voyada.whitebg {
    background: #fff;
    color: #333;
  }

  .header-voyada .logo {
    width: 135px;
  }
  .header-voyada.bbg .logo img:first-child {
    display: none;
  }
  .header-voyada.bbg .logo img:last-child {
    display: block;
  }
  .header-voyada.whitebg .logo img:first-child {
    display: block;
  }
  .header-voyada.whitebg .logo img:last-child {
    display: none;
  }

  .mobile-icons {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .header-voyada.whitebg .mobile-icons :deep(.currency-selector--compact) {
    border-color: #ddd;
  }

  .mobile-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    flex-shrink: 0;
  }

  .usermenu {
    border: 1px solid #ddd !important;
    top: 4rem;
    background: #fff;
    height: auto;
    width: 16rem;
    right: 1.5rem;
    z-index: 99999 !important;
  }
}
</style>
